export default [
  {
    name: 'facebook',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(facebook\.com)/i
  },
  {
    name: 'youtube',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7],
    regex: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(?:-nocookie)?\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/i,
    url: 'https://www.youtube-nocookie.com/embed/$5',
    attributes: {
      allow: 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      allowfullscreen: true
    }
  },
  {
    name: 'vimeo',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4],
    regex: /^.*vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
    url: 'https://player.vimeo.com/video/$1',
    attributes: {
      allow: 'fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share',
      allowfullscreen: true
    }
  },
  {
    name: 'dailymotion',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4],
    regex: /^((?:https?:)?\/\/)?((?:www|geo)\.)?(dailymotion\.com|dai\.ly)(?:\/(?:embed\/)?(?:video\/)?([A-Za-z0-9]+)|\/player\.html\?video=([A-Za-z0-9]+))(?:[^#&?\s]*)?$/i,
    url: 'https://geo.dailymotion.com/player.html?video=$4$5',
    attributes: {
      allow: 'fullscreen; picture-in-picture',
      allowfullscreen: true
    }
  },
  {
    name: 'google_maps',
    purpose: 'marketing',
    purposes: [1, 3, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(google\.com\/maps)/i
  },
  {
    name: 'google_fonts',
    purpose: 'functional',
    purposes: [1, 10]
  },
  {
    name: 'mixpanel',
    purpose:'analytics',
    purposes: [1, 6]
  },
  {
    name: 'sentry',
    purpose:'analytics',
    purposes: [1, 7, 10]
  },
  {
    name: 'twitch_video',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 8, 9, 10],
    regex: /^((?:https?:)?\/\/)?((?:www|m|player)\.)?(twitch\.tv)(?:\/videos\/(\d+)|\/\?video=(\d+)(?:&[^\s]*)?)$/i,
    url: 'https://player.twitch.tv/?video=$4$5',
    attributes: {
      allow: 'fullscreen; picture-in-picture',
      allowfullscreen: true,
      scrolling: 'no'
    },
    params: {
      parent: window.location.hostname
    }
  },
  {
    name: 'twitch_channel',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 8, 9, 10],
    regex: /^((?:https?:)?\/\/)?((?:www|m|player)\.)?(twitch\.tv)(?:\/([a-zA-Z0-9_]+)|\/\?channel=([a-zA-Z0-9_]+)(?:&[^\s]*)?)$/i,
    url: 'https://player.twitch.tv/?channel=$4$5',
    attributes: {
      allow: 'fullscreen; picture-in-picture',
      allowfullscreen: true,
      scrolling: 'no'
    },
    params: {
      parent: window.location.hostname
    }
  },
  {
    name: 'tiktok',
    category: 'video',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 8, 9, 10],
    regex: /^((?:https?:)?\/\/)?((?:www|vm|vt|m)\.)?tiktok\.com\/(?:@[^\/]+\/video\/|v\/|embed\/v2\/|player\/v1\/)(\d+)(\S+)?$/i,
    url: 'https://www.tiktok.com/player/v1/$3',
    attributes: {
      allow: 'fullscreen; encrypted-media',
      allowfullscreen: true
    }
  },
  {
    name: 'garmin',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10], // Store/access info, content selection, measurement, insights
    regex: /^((?:https?:)?\/\/)?((?:www|connect)\.)?(garmin\.com)/i
  },
  {
    name: 'mapmyrun',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(mapmyrun\.com)/i
  },
  {
    name: 'mapmyride',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(mapmyride\.com)/i
  },
  {
    name: 'komoot',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(komoot\.com)/i
  },
  {
    name: 'linkedin',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 8, 9, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(linkedin\.com)/i
  },
  {
    name: 'openstreetmap',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(openstreetmap\.org)/i
  },
  {
    name: 'strava',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10],
    regex: /^((?:https?:)?\/\/)?((?:www)\.)?(strava\.com)/i
  },
  {
    name: 'deburen',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 3, 4, 5, 7, 8, 9, 10],
    regex: /^((?:https?:)?\/\/)?(embed\.)?(deburen\.tv)/i
  },
  {
    name: 'timeanddate',
    category: 'iframe',
    purpose: 'marketing',
    purposes: [1, 4, 7, 10],
    regex: /^((?:https?:)?\/\/)?(free\.)?(timeanddate\.com)/i
  }
]